export function timeout(duration: number){
    return new Promise((res)=>{
        setTimeout(res, duration);
    });
}